export default defineNuxtPlugin(async (nuxtApp) => {
  // if (process.client) {
  // @ts-expect-error - vue-the-mask is not typed
    const VueTheMask = (await import('vue-the-mask')).default
    nuxtApp.vueApp.use(VueTheMask)
  // }
})